export function setPageTitle(title) {
  if (title) {
    document.title = title;
  }
}
